import React from 'react'
import './style.css'
import Button from '../../CtaButton'
import AuraButtonGreen from '../AuraButton/AuraButtonGreen'

const AuraTestimonial = () => {
    return (
        <>
            <section className='aura-testimonials-card-main-box'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="aura-testimonials-card">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="aura-clinic-practitioner-card">
                                                <img
                                                    src="/images/testimonials/sarah.avif"
                                                    alt="Practitioner"
                                                    className="aura-testimonials-img rounded-circle"
                                                />

                                                <p className="aura-testimonials-name">
                                                    PRACTITIONER
                                                </p>
                                                <span className="aura-testimonials-role">
                                                    Dr. Emily Hart <br />
                                                    General Practitioner at Riverside Family Health
                                                </span>

                                                <p className="aura-testimonials-name mt-3">
                                                    PRACTICE SIZE
                                                </p>
                                                <span className="aura-testimonials-role">
                                                    6 GPs
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-9">
                                            <blockquote className="aura-testimonials-quote">
                                                Aura Clinic has completely transformed the way we manage patient intake.
                                                What used to take 15 minutes now takes less than 3. The accuracy, the speed, and the reduction in paperwork have been unbelievable. <br />
                                                We finally feel like our clinic is operating in the future  not the past.
                                            </blockquote>

                                            {/* <div className="d-flex justify-content-end mt-4">
                                                <AuraButtonGreen text='Read case study' link='#' />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AuraTestimonial